import { render, staticRenderFns } from "./EventDateCard.vue?vue&type=template&id=5a221622&scoped=true&"
import script from "./EventDateCard.vue?vue&type=script&lang=js&"
export * from "./EventDateCard.vue?vue&type=script&lang=js&"
import style0 from "./EventDateCard.vue?vue&type=style&index=0&id=5a221622&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a221622",
  null
  
)

export default component.exports